import React from 'react';
import { useNavigate } from 'react-router-dom';
import MyDataHaes from './myDataHaes';
import './css/srvHaes.css';
import SRVHaesApplies from './srvHaesApplies';
import SRVSpareParts from './srvSpareParts';
import cfg from '../config';

const HaesManagement = () => {
    const navigate = useNavigate();

    return (
        <div className="container mt-5">
            <h1 className="mb-4 text-center">{cfg.costumeTermPlural} verwalten</h1>

            <div className="d-grid gap-3 mb-4">
                <button
                    className="btn btn-primary btn-lg"
                    onClick={() => navigate('/service-apply-haes')}
                >
                    {cfg.costumeTerm} beantragen
                </button>
                <button
                    className="btn btn-secondary btn-lg"
                    onClick={() => navigate('/service-order-spare-parts', { state: { status: "create" } })}
                    >
                    Ersatzteile bestellen
                    </button>

            </div>

            <div className="mt-5">
                <MyDataHaes />
            </div>
            <br/>
            <hr/>
            <br/>
            <div className='mt-5'>
                <SRVHaesApplies />
            </div>
            <br/>
            <br/>
            <hr/>
            <br/>
            <div className='mt-5'>
                <SRVSpareParts />
            </div>
            <br/>
            
        </div>
    );
};

export default HaesManagement;
